import { render } from "./ScenicEcharts.vue?vue&type=template&id=35653bc8"
import script from "./ScenicEcharts.vue?vue&type=script&lang=js"
export * from "./ScenicEcharts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__